import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_deal_event_RowInterface {
  
    guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid : fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  txn_type : fromDatatype.VarcharDatatypeInterface;
  action : fromDatatype.VarcharDatatypeInterface;
  descr : fromDatatype.VarcharArrayDatatypeInterface;
  message_json : fromDatatype.VarcharArrayDatatypeInterface;
  completed_date : fromDatatype.TimestampTzDatatypeInterface;
  event_code : fromDatatype.VarcharArrayDatatypeInterface;
  id_user : fromDatatype.VarcharArrayDatatypeInterface;
  id_device : fromDatatype.VarcharDatatypeInterface;
  id_user_agent : fromDatatype.VarcharDatatypeInterface;
  txn_date : fromDatatype.TimestampTzDatatypeInterface;
  foreign_table : fromDatatype.VarcharArrayDatatypeInterface;
  foreign_key : fromDatatype.VarcharArrayDatatypeInterface
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;
}

export class bl_sfa_deal_event_RowClass implements bl_sfa_deal_event_RowInterface {

    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid : fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    txn_type : fromDatatype.VarcharDatatypeInterface;
    action : fromDatatype.VarcharDatatypeInterface;
    descr : fromDatatype.VarcharArrayDatatypeInterface;
    message_json : fromDatatype.VarcharArrayDatatypeInterface;
    completed_date : fromDatatype.TimestampTzDatatypeInterface;
    event_code : fromDatatype.VarcharArrayDatatypeInterface;
    id_user : fromDatatype.VarcharArrayDatatypeInterface;
    id_device : fromDatatype.VarcharDatatypeInterface;
    id_user_agent : fromDatatype.VarcharDatatypeInterface;
    txn_date : fromDatatype.TimestampTzDatatypeInterface;
    foreign_table : fromDatatype.VarcharArrayDatatypeInterface;
    foreign_key : fromDatatype.VarcharArrayDatatypeInterface
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status : fromDatatype.StatusDataFieldInterface
    revision : fromDatatype.GuidDataFieldInterface
    vrsn : fromDatatype.VarcharDatatypeInterface;

}
